import React from 'react';
const pains = [{
  emoji: '😰',
  title: 'Pianificazione Costante delle Sessioni',
  description: 'Passi ore ogni settimana a creare routine, adattare i livelli di movimento e organizzare sessioni per allieve con obiettivi e capacità completamente diverse.'
}, {
  emoji: '⚠️',
  title: 'Paura di Chiedere Troppo... O Troppo Poco',
  description: 'Ti chiedi continuamente se le tue allieve si stanno impegnando abbastanza per migliorare, o se stai chiedendo troppo rischiando di scoraggiarle o affaticarle.'
}, {
  emoji: '📚',
  title: 'Informazioni Ovunque',
  description: 'Trovi metodi di danza, tecniche di movimento e consigli da ogni parte, ma nulla è organizzato in un sistema completo che tu possa seguire con sicurezza e professionalità.'
}, {
  emoji: '😩',
  title: 'Esaurimento Mentale',
  description: "Tra la pianificazione delle sessioni, il monitoraggio dei progressi, l'adattamento dei programmi e le domande delle allieve, rimane pochissimo tempo per concentrarti su ciò che conta: aiutarle a trasformarsi."
}];
export function PainSection() {
  return <section className="py-6 px-4 sm:px-6 bg-brand-cream" data-id="element-102">
      <h2 className="text-2xl sm:text-3xl font-heading font-bold text-center text-brand-taupe mb-1 uppercase leading-tight" data-id="element-103">
        LO RICONOSCI?
      </h2>

      <p className="text-sm sm:text-base text-brand-taupe font-semibold text-center mb-4 leading-tight" data-id="element-104">
        Ami insegnare danza, ma la pianificazione ti consuma l'intera settimana?
        <br data-id="element-105" />
        <span className="text-brand-rose" data-id="element-106">
          Se sei un'insegnante di danza, coach di movimento o istruttrice di
          fitness dance, probabilmente conosci una di queste situazioni:
        </span>
      </p>

      <div className="flex flex-col gap-2" data-id="element-107">
        {pains.map((pain, i) => <div key={i} className="bg-white p-3 rounded-md border-l-4 border-brand-rose shadow-sm flex gap-3 items-start" data-id="element-108">
            <div className="text-2xl leading-none shrink-0" data-id="element-109">{pain.emoji}</div>
            <div data-id="element-110">
              <h3 className="text-sm font-bold text-brand-taupe mb-0.5 uppercase tracking-tight" data-id="element-111">
                {pain.title}
              </h3>
              <p className="text-brand-taupe/80 text-xs sm:text-sm font-medium leading-tight" data-id="element-112">
                {pain.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}